import { ReactNode } from 'react'

import Tooltip from 'app/common/ui/Tooltip'

import styles from './ComplexTooltip.module.scss';

type Props = {
  title: string
  items: Array<string>
  children: ReactNode
}

const ComplexTooltip = ({ title, items, children }: Props) => {
  const content = (
    <div className={styles.root}>
      <div className={styles.header}>{title}</div>
      <ul className={styles.list}>
        {items.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    </div>
  )

  return <Tooltip content={content}>{children}</Tooltip>
}

export default ComplexTooltip
